import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData } from "../../../services/apiService";

const GET_ISO_ENROLLMENT_LIST = "isoEnrollment/getList";
const UPDATE_ISO = "isoEnrollment/update";

export const getIsoEnrollmentList = createAsyncThunk(
  GET_ISO_ENROLLMENT_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    const { token, acquirerData, page, page_size, search } = payload;
    const endpoint = "/list-iso";
    const timestamp = new Date().toISOString();
    try {

      const data = {
        version: "04.09.01",
        acquirerID: acquirerData.acquirerId,
        timeStamp: timestamp,
        page,
        page_size,
        ...(search && { search }),
      };

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerData.acquirerName,
        acquirerID: acquirerData.acquirerId,
      };

      const response = await fetchData({ endpoint, data, headers, token });

      return response.data
    } catch (error) {
      console.error("Error fetching enrollment data thunk:", error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateIso = createAsyncThunk(
  UPDATE_ISO,
  async (payload, { rejectWithValue }) => {
    const { token, acquirerData, isoData } = payload;
    const endpoint = "/update-iso";
    const timestamp = new Date().toISOString();
    
    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerData.acquirerName,
        acquirerID: acquirerData.acquirerId,
      };

      const data = {
        version: "04.09.01",
        acquirerID: acquirerData.acquirerId,
        fiat: {
          currencyCode: isoData.isoCurrencyCode,
        },
        isoID: isoData.isoID,
        isoName: isoData.isoName,
        iso: isoData.iso,
        bank: isoData.bank,
        crypto_wallets: isoData.crypto_wallets,
        timeStamp: timestamp,
      };

      const response = await fetchData({ endpoint, data, headers, token });
      
      return response.data;
    } catch (error) {
      console.error("Error updating ISO:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
